export default "__VITE_ASSET__85ad6a2c__"